export default __webpack_public_path__ + "static/media/edit-modal.2c59e3f3.svg";